'use client';

import { useEffect } from 'react';

import { ErrorBlock } from '@components/error-block';

import { paths } from '@helpers/path';

type ErrorPageProps = { error: Error & { digest?: string }; reset: () => void };

export default function ErrorPage({ error }: Readonly<ErrorPageProps>) {
    useEffect(() => {
        // Log the error to an error reporting service
        console.error(error);
    }, [error]);

    return <ErrorBlock link={paths.phoneWall} text='Retourner sur le mur de téléphone' />;
}
